<template>
  <div>
    <template v-if="layout === 'home'">
      <template v-if="events.upcoming.length > 0">
        <div class="w3-col s12 m6 l4 profile" v-for="event of $options.filters.limit(events.upcoming, 6)" :key="event.name" @mouseleave="slide(event, 'down')">
          <div v-if="event.image != ''" :ref="event.eventid" class="card hovercard" @mouseenter="slide(event, 'up')">
            <div class="cardheader" v-bind:style="{'background-image': 'url(' + event.image + ')','background-size':'cover'}"></div>
            <div class="info" :style="{'top': event.infoTop}" @click="eventNav(event)">
              <div class="eventTitle truncate">{{event.title}}</div>
              <div class="eventDate">{{event.dates[0].date | date('day')}}</div>
              <div style="padding:0 20px;">
                <hr />
              </div>
              <div class="desc">{{event.description | truncate(150)}}</div>
              <div class="eventDetailsLink">
                EVENT DETAILS
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="whiteContainer">
          No upcoming events. <a href="/organizers">Let us know about your events!</a>
        </div>
      </template>
    </template>
    <template v-if="layout === 'wide' || layout === 'thin'">
      <ul class="event-list pointer" ref="eventlist">
        <li class="eventItem" v-for="(event, index) of $options.filters.limit(eventList, limit)" :key="index" :style="{'animation-delay': (index * .2) + 's'}">
          <template v-if="event.billing && showAds">
            <ads type="inline"></ads>
          </template>
          <template v-else>
            <time :datetime="event.start" v-if="date" @click="eventNav(event)" class="w3-row">
              <template v-if="event.dates.length > 0">
                <span class="day w3-col s4 m12">{{event.dates[0].date | date('dayNumber')}}</span>
                <span class="month w3-col s4 m12">{{event.dates[0].date | date('monthStringShort')}}</span>
                <span class="year w3-col s4 m12">{{event.dates[0].date | date('year')}}</span>
              </template>
            </time>
            <template v-if="width > 600">
              <img v-if="event.image !== '' && image" :alt="event.title" :src="event.image" @click="eventNav(event)" />
              <div class="info" v-if="layout === 'wide'" @click="eventNav(event)">
                <h2 class="title">{{event.title}}</h2>
                <p class="desc lato">{{event.description | truncate(200)}}</p>
              </div>
              <div class="info" style="padding:0 20px 0 12px;" v-if="layout === 'thin'" @click="eventNav(event)">
                <h2 class="title thin">{{event.title}}</h2>
                <p class="desc" style="font-size:11pt;">{{event.description | truncate(100)}}</p>
              </div>
            </template>
            <template v-if="width < 601">
              <div @click="eventNav(event)">
                <div class='eventItemImage' style="height:78px; width:25%; display:inline-block; vertical-align:top" :style="{'background-image': 'url(' + event.image + ')'}"></div>
                <div class="info" style="width:74%; display:inline-block; vertical-align:top; padding-left:8px;">
                  <h2 class="title">{{event.title}}</h2>
                  <p class="desc" style="font-size:11pt; padding-bottom:0">{{event.description | truncate(80)}}</p>
                </div>
              </div>
            </template>
            <div class="social w3-hide-small">
              <ul v-if="edit">
                <li class="eventAction edit"><a @click="editEvent(event)" class="w3-display-container"><font-awesome-icon icon="pencil-alt" class="w3-text-green w3-display-middle"></font-awesome-icon></a></li>
                <li class="eventAction clone"><a @click="cloneEvent(event)" class="w3-display-container"><font-awesome-icon icon="copy" class="w3-text-blue w3-display-middle"></font-awesome-icon></a></li>
                <li class="eventAction remove"><a @click="removeEvent(event)" class="w3-display-container"><font-awesome-icon icon="trash" class="w3-text-red w3-display-middle"></font-awesome-icon></a></li>
              </ul>
              <ul v-if="social">
                <li class="facebook eventAction"><a :href="share('fb', event.url)" aria-label="facebook share" target="_blank" rel="noreferrer" class="w3-display-container"><font-awesome-icon :icon="['fab', 'facebook-f']" class="w3-text-blue w3-display-middle"></font-awesome-icon></a></li>
                <li class="twitter eventAction"><a :href="share('tw', event.url)" aria-label="twitter share" target="_blank" rel="noreferrer" class="w3-display-container"><font-awesome-icon :icon="['fab', 'twitter']" class="w3-text-light-blue w3-display-middle"></font-awesome-icon></a></li>
                <li class="google-plus eventAction"><a :href="share('gp', event.url)" aria-label="google share" target="_blank" rel="noreferrer" class="w3-display-container"><font-awesome-icon :icon="['fab', 'google-plus']" class="w3-text-red w3-display-middle"></font-awesome-icon></a></li>
              </ul>
            </div>
          </template>
          <template v-if="userPage && !event.approved">
            <button class="w3-button w3-block w3-red">Pending</button>
          </template>
        </li>
      </ul>
    </template>
    <template v-if="layout === 'search'">
      <ul class="event-list pointer" ref="eventlist">
        <li class="eventItem" v-for="(event, index) of eventList" :key="index" :style="{'animation-delay': (index * .2) + 's'}">
          <time :datetime="event.start" @click="eventPreview(event)">
            <template v-if="event.dates.length > 0">
              <span class="day">{{event.dates[0].date | date('dayNumber')}}</span>
              <span class="month">{{event.dates[0].date | date('monthStringShort')}}</span>
              <span class="year">{{event.dates[0].date | date('year')}}</span>
            </template>
          </time>
          <img v-if="event.image !== ''" :alt="event.title" :src="event.image" @click="eventPreview(event)" />
          <div class="info" @click="eventPreview(event)">
            <h2 class="title">{{event.title}}</h2>
            <p class="desc lato">{{event.description | truncate(200)}}</p>
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'events',
  props: {
    type: String,
    social: Boolean,
    date: Boolean,
    image: Boolean,
    edit: Boolean,
    layout: String,
    showAds: Boolean,
    userPage: Boolean,
    limit: Number
  },
  data() {
    return {
      dataLoaded: false,
      showPreview: false,
      width: window.innerWidth
    }
  },
  computed: {
    eventList() {
      if (this.userPage) {
        if (this.initSearch !== '') {
          // TODO: search when on user page
        }
        return this.userEvents[this.type]
      } else {
        let events = this.events[this.type]
        if (this.initSearch !== '') {
          filteredEvents = events.filter((event) => {
            if (this.initSearch === 'sporting') {
              let terms = ['soccer','football','cricket','field hockey','tennis','volleyball','basketball','baseball','rugby','golf','super bowl']
              for (let term of terms) {
                if (event.title.toLowerCase().includes(term) || event.description.toLowerCase().includes(term))  {
                  return event
                }
              }
            }
            if (this.initSearch === 'music') {
              let terms = ['music','concert','singer','musician','dance','dancing','singing','musical','symphony','orchestra']
              for (let term of terms) {
                if (event.title.includes(term) || event.description.includes(term))  {
                  return event
                }
              }
            }
            if (this.initSearch === 'art') {
              let terms = ['fine art','museum','art gallery','theatre','symphony','orchestra']
              for (let term of terms) {
                if (event.title.includes(term) || event.description.includes(term))  {
                  return event
                }
              }
            }
            if (this.initSearch === 'vehicle') {
              let terms = ['car show','auto show','car meet','car club','auto club','car racing']
              for (let term of terms) {
                if (event.title.includes(term) || event.description.includes(term))  {
                  return event
                }
              }
            }
            if (this.initSearch === 'seasonal') {
              let terms = ['christmas','new year\'s','labor day','groundhog day','valentine\'s day','st. patrick','easter','cinco de mayo','halloween','thanksgiving','chanukah']
              for (let term of terms) {
                if (event.title.includes(term) || event.description.includes(term))  {
                  return event
                }
              }
            }
            if (this.initSearch === 'all') {
              return event
            }
          })
          return filteredEvents
        } else {
          return events
        }
      }
    },
    ...mapState([
      'user',
      'events',
      'userEvents',
      'initSearch',
      'activeAds'
    ])
  },
  created() {
    this.$store.dispatch('getUserEvents', this.user)
    this.$store.dispatch('getEvents').then(() => {
      let index = 0
      let ad = 0
      let adsLeft = this.activeAds.length
      let defaultAd = {
        billing: {},
        charges: [],
        images: {
          inline: '',
          mobile: '',
          sidebar: ''
        },
        button: 'View Pricing',
        buttonColor: 'w3-green',
        color: 'adItem',
        email: 'darren@gomobile7.com',
        start: '',
        end: '',
        placement: 'global',
        status: 'Active',
        title: 'Advertise Here!',
        text: 'Reach local users interested in your products / services',
        url: 'https://daytonalocal.com/advertisers'
      }
      for (event of this.events[this.type]) {
        if (((index+1) % 4 === 0) && this.showAds && adsLeft > 0) {
          this.events[this.type].splice(index, 0, this.activeAds[ad])
          adsLeft--
          ad++
        } else if (((index+1) % 4 === 0) && this.showAds && adsLeft == 0) {
          this.events[this.type].splice(index, 0, defaultAd)
        }
        index++
      }
      if (this.limit && this.limit > 0) {
        this.events[this.type].slice(0, (this.limit + 1))
      }
    })
  },
  mounted() {
    window.onresize = () => {
      this.width = window.innerWidth
    }
  },
  methods: {
    editEvent(event) {
      this.$emit('edit-event', event)
    },
    cloneEvent(event) {
      this.$emit('clone-event', event)
    },
    removeEvent(event) {
      if(confirm("Delete event " + event.title + '?')) {
        this.$store.dispatch('removeEvent', event).then(result => {
          this.$store.dispatch('getUserEvents', this.user);
        });
      }
    },
    eventNav(event) {
      this.$router.push({ name: 'event-details', params: {url: event.url} })
      window.scrollTo(0, 0)
    },
    eventPreview(event) {
      this.$store.commit('setSelectedEvent', event)
      this.$emit('showPreview', true)
      this.showPreview = true
      window.scrollTo(0, 0)
    },
    share(type, url) {
      let sharePage = ""
      if (type === 'fb') {
        sharePage = encodeURI("https://www.facebook.com/sharer.php?u=https://daytonalocal.com/event-details/" + url);
      } else if (type === 'tw') {
        sharePage = encodeURI("https://twitter.com/intent/tweet?url=https://daytonalocal.com/event-details/" + url);
      } else if (type === 'gp') {
        sharePage = encodeURI("https://plus.google.com/share?url=https://daytonalocal.com/event-details/" + url);
      } else {
        // nothing
      }
      return sharePage;
    },
    slide(event, direction) {
      if (direction === 'up') {
        this.$refs[event.eventid][0].children[1].style.top = '0'
      } else if (direction === 'down') {
        this.$refs[event.eventid][0].children[1].style.top = '150px'
      }
    },
    selectEvent(event) {
      this.$emit('selectEvent', event)
    },
    hasMore(index) {
      if (index / 4 < this.activeAds.length) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
</style>
